import React from "react";
import { useTranslate } from "@pankod/refine-core";
import { Form, InputNumber } from "@pankod/refine-antd";
import { ILanguage } from "interfaces";
import { TranslatedField } from "../TranslatedField";
import { AssetUploadField } from "../AssetUploadField";

interface Props {
  fieldName: number; // antd Form.List field.name (index into the levels array)
  languages: ILanguage[];
}

export const JigsortLevelConfig: React.FC<Props> = ({ fieldName, languages }) => {
  const t = useTranslate();
  return (
    <>
      <Form.Item
        label={t("event.thematic.jigsort_image")}
        name={[fieldName, "config", "image"]}
        rules={[
          {
            required: true,
            message: t("event.thematic.jigsort_image_required"),
          },
        ]}
      >
        <AssetUploadField kind="thematic-events" />
      </Form.Item>
      <Form.Item label={t("event.thematic.title")}>
        {/* Relative to the enclosing Form.List name=["thematic","levels"];
            TranslatedField composes the absolute path internally for useWatch. */}
        <TranslatedField
          languages={languages}
          fieldPath={[fieldName, "config", "title"]}
        />
      </Form.Item>
      <Form.Item label={t("event.thematic.description")}>
        <TranslatedField
          languages={languages}
          fieldPath={[fieldName, "config", "description"]}
          multiline
        />
      </Form.Item>
      <Form.Item
        label={t("event.thematic.difficulty")}
        name={[fieldName, "config", "difficulty"]}
      >
        <InputNumber min={1} />
      </Form.Item>
    </>
  );
};
